import { graphql } from '../gql';

export const getRepoFilesQuery = graphql(`
  query GetRepoFiles($getRepoFilesRequest: GetRepoFilesRequest!) {
    GetRepoFiles(getRepoFilesRequest: $getRepoFilesRequest) {
      commitId
      sdkVersion
      files {
        path
        content
      }
    }
  }
`);
